import { Button, ButtonStyles, Tooltip } from '@silverfort/sf-components';
import { FC } from 'react';

interface Props {
    onClose: () => void;
    onGenerate: () => void;
    errors: string[];
    isGenerating: boolean;
}

const InsuranceReportFooter: FC<Props> = ({ onClose, onGenerate, errors, isGenerating }) => {
    return (
        <div className="flex justify-end items-center gap-[8px]">
            <Button text="Cancel" onClick={onClose} buttonStyle={ButtonStyles.GhostSolid} />
            {errors.length > 0 ? (
                <Tooltip title="validation errors:" description={errors.join(', ')}>
                    <Button
                        text="Generate Report"
                        onClick={onGenerate}
                        disabled
                        buttonStyle={ButtonStyles.PrimarySolid}
                    />
                </Tooltip>
            ) : (
                <Button
                    text="Generate Report"
                    onClick={onGenerate}
                    disabled={isGenerating}
                    buttonStyle={ButtonStyles.PrimarySolid}
                />
            )}
        </div>
    );
};

export default InsuranceReportFooter;
